import React from "react";
import { Button } from "../../Common/Buttons/Button";
import DropdownMenu, { ActionsProps } from "../../Inputs/DropdownMenu";

const DropdownButton: DropdownMenu["customButton"] = ({
  onClick,
  disabled,
}) => {
  return (
    <Button
      variant="outlineInverted"
      title="Actions"
      onClick={onClick}
      isDisabled={disabled}
      size="small"
      iconEnd="chevron-down"
    />
  );
};

type CarouselModalActionButtonProps = {
  actions: ActionsProps[];
};

export function CarouselModalActionButton({
  actions,
}: CarouselModalActionButtonProps) {
  if (actions.length === 0) {
    return null;
  }

  return (
    <DropdownMenu
      buttonText="Actions"
      actions={actions}
      customButton={DropdownButton}
    />
  );
}
